import {createStore, applyMiddleware, compose} from 'redux';
import thunk from 'redux-thunk';
import rootReducer from './reducers';

const initialState = {};

const middleware = [thunk];

const initializeStore = () => {
    if (window.__REDUX_DEVTOOLS_EXTENSION__) {
        return createStore(
            rootReducer,
            initialState,
            compose(
                applyMiddleware(...middleware),
                window.__REDUX_DEVTOOLS_EXTENSION__()
            ),
        );
    }
    return createStore(
        rootReducer,
        initialState,
        compose(applyMiddleware(...middleware)),
    );
};

const store = initializeStore();
export default store;


// WEBPACK FOOTER //
// ./src/store.jsx